export default __webpack_public_path__ + "static/media/SEI_ABC - 0039416718 - Edital de Cursos.0e15c0fc.pdf";